import request from '@/utils/request';

function postMakePreselectionForPlanningOption(data) {
  return request({
    data: data,
    method: 'post',
    url: 'productionplanningpreselection/makePreselectionForProductGroup',
    timeout: 120000
  });
}

function getWorkshopsInPlanning(domainID, planningOption) {
  return request({
    method: 'get',
    url: 'productionplanningselection/getWorkshopsInPlanning',
    params: {
      domainID: domainID,
      planningOption: planningOption
    }
  });
}
function getProposalForWorkshop(domainID, workshopID, planningOption) {
  return request({
    method: 'get',
    url: 'productionplanningselection/getProposalForWorkshop',
    params: {
      domainID: domainID,
      workshopID: workshopID,
      planningOption: planningOption
    },
    timeout: 120000
  });
}

function postSelectionForWorkshop(
  domainID,
  workshopID,
  planningOption,
  selection,
  excludeDiverseLiningYN,
  selectByDateYN
) {
  return request({
    data: { domainID, workshopID, planningOption, selection, excludeDiverseLiningYN, selectByDateYN },
    method: 'post',
    url: 'productionplanningselection/makeSelectionForWorkshop',
    timeout: 120000
  });
}

function generateFilteredSelectionForWorkshop(
  domainID,
  workshopID,
  planningOption,
  yarnIDs,
  strictlySelectedYarns,
  excludeDiverseLiningYN,
  selectByDateYN
) {
  return request({
    data: {
      domainID,
      workshopID,
      planningOption,
      yarnIDs,
      strictlySelectedYarns,
      excludeDiverseLiningYN,
      selectByDateYN
    },
    method: 'post',
    url: 'productionplanningselection/filterSelectionForWorkshop',
    timeout: 120000
  });
}

export const storeExtensions = {
  actions: {
    postMakePreselectionForPlanningOption({ dispatch }, data) {
      return new Promise((resolve, reject) =>
        postMakePreselectionForPlanningOption(data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getWorkshopsInPlanning({ dispatch }, { domainID, planningOption }) {
      return new Promise((resolve, reject) =>
        getWorkshopsInPlanning(domainID, planningOption)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getProposalForWorkshop({ dispatch }, { domainID, workshopID, planningOption }) {
      return new Promise((resolve, reject) =>
        getProposalForWorkshop(domainID, workshopID, planningOption)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    postSelectionForWorkshop(
      { commit },
      { domainID, workshopID, planningOption, selection, excludeDiverseLiningYN, selectByDateYN }
    ) {
      return new Promise((resolve, reject) =>
        postSelectionForWorkshop(
          domainID,
          workshopID,
          planningOption,
          selection,
          excludeDiverseLiningYN,
          selectByDateYN
        )
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    generateFilteredSelectionForWorkshop(
      { dispatch },
      { domainID, workshopID, planningOption, yarnIDs, strictlySelectedYarns, excludeDiverseLiningYN, selectByDateYN }
    ) {
      return new Promise((resolve, reject) =>
        generateFilteredSelectionForWorkshop(
          domainID,
          workshopID,
          planningOption,
          yarnIDs,
          strictlySelectedYarns,
          excludeDiverseLiningYN,
          selectByDateYN
        )
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
